export const airVolume = [
  {
    x: 0,
    y: 120,
  },
  {
    x: 20,
    y: 132,
  },
  {
    x: 40,
    y: 144.4,
  },
  {
    x: 60,
    y: 156.4,
  },
  {
    x: 80,
    y: 168.4,
  },
  {
    x: 100,
    y: 180.8,
  },
  {
    x: 120,
    y: 192.8,
  },
  {
    x: 140,
    y: 204.8,
  },
  {
    x: 160,
    y: 217.20000000000002,
  },
  {
    x: 180,
    y: 229.20000000000002,
  },
  {
    x: 200,
    y: 241.20000000000002,
  },
  {
    x: 220,
    y: 253.60000000000002,
  },
  {
    x: 240,
    y: 265.6,
  },
  {
    x: 260,
    y: 277.6,
  },
  {
    x: 280,
    y: 290,
  },
  {
    x: 300,
    y: 302,
  },
  {
    x: 320,
    y: 314,
  },
  {
    x: 340,
    y: 326.40000000000003,
  },
  {
    x: 360,
    y: 338.40000000000003,
  },
  {
    x: 380,
    y: 350.40000000000003,
  },
  {
    x: 400,
    y: 362.8,
  },
  {
    x: 420,
    y: 374.8,
  },
  {
    x: 440,
    y: 386.8,
  },
  {
    x: 460,
    y: 399.20000000000005,
  },
  {
    x: 480,
    y: 411.20000000000005,
  },
  {
    x: 500,
    y: 423.20000000000005,
  },
  {
    x: 520,
    y: 435.6,
  },
  {
    x: 540,
    y: 447.6,
  },
  {
    x: 560,
    y: 459.6,
  },
  {
    x: 580,
    y: 472,
  },
  {
    x: 600,
    y: 484,
  },
  {
    x: 620,
    y: 496,
  },
  {
    x: 640,
    y: 498,
  },
  {
    x: 660,
    y: 498,
  },
  {
    x: 680,
    y: 498,
  },
  {
    x: 700,
    y: 498,
  },
  {
    x: 720,
    y: 498,
  },
  {
    x: 740,
    y: 498,
  },
  {
    x: 760,
    y: 498,
  },
  {
    x: 780,
    y: 498,
  },
  {
    x: 800,
    y: 498,
  },
  {
    x: 820,
    y: 498.40000000000003,
  },
  {
    x: 840,
    y: 498.40000000000003,
  },
  {
    x: 860,
    y: 498.40000000000003,
  },
  {
    x: 880,
    y: 498.40000000000003,
  },
  {
    x: 900,
    y: 498.40000000000003,
  },
  {
    x: 920,
    y: 498.40000000000003,
  },
  {
    x: 940,
    y: 498.40000000000003,
  },
  {
    x: 960,
    y: 498.40000000000003,
  },
  {
    x: 980,
    y: 498.40000000000003,
  },
  {
    x: 1000,
    y: 498.40000000000003,
  },
  {
    x: 1020,
    y: 498.40000000000003,
  },
  {
    x: 1040,
    y: 498.40000000000003,
  },
  {
    x: 1060,
    y: 490.8,
  },
  {
    x: 1080,
    y: 469.20000000000005,
  },
  {
    x: 1100,
    y: 451.20000000000005,
  },
  {
    x: 1120,
    y: 434,
  },
  {
    x: 1140,
    y: 416.40000000000003,
  },
  {
    x: 1160,
    y: 400.40000000000003,
  },
  {
    x: 1180,
    y: 384.40000000000003,
  },
  {
    x: 1200,
    y: 368.8,
  },
  {
    x: 1220,
    y: 354.40000000000003,
  },
  {
    x: 1240,
    y: 340,
  },
  {
    x: 1260,
    y: 326,
  },
  {
    x: 1280,
    y: 312.40000000000003,
  },
  {
    x: 1300,
    y: 298.8,
  },
  {
    x: 1320,
    y: 285.2,
  },
  {
    x: 1340,
    y: 272,
  },
  {
    x: 1360,
    y: 259.2,
  },
  {
    x: 1380,
    y: 246.8,
  },
  {
    x: 1400,
    y: 234.8,
  },
  {
    x: 1420,
    y: 222.8,
  },
  {
    x: 1440,
    y: 211.20000000000002,
  },
  {
    x: 1460,
    y: 199.60000000000002,
  },
  {
    x: 1480,
    y: 188.8,
  },
  {
    x: 1500,
    y: 178.4,
  },
  {
    x: 1520,
    y: 167.60000000000002,
  },
  {
    x: 1540,
    y: 157.60000000000002,
  },
  {
    x: 1560,
    y: 148,
  },
  {
    x: 1580,
    y: 138.8,
  },
  {
    x: 1600,
    y: 129.6,
  },
  {
    x: 1620,
    y: 120.80000000000001,
  },
  {
    x: 1640,
    y: 112.4,
  },
  {
    x: 1660,
    y: 104.4,
  },
  {
    x: 1680,
    y: 96.80000000000001,
  },
  {
    x: 1700,
    y: 89.2,
  },
  {
    x: 1720,
    y: 82,
  },
  {
    x: 1740,
    y: 75.60000000000001,
  },
  {
    x: 1760,
    y: 69.2,
  },
  {
    x: 1780,
    y: 63.2,
  },
  {
    x: 1800,
    y: 57.6,
  },
  {
    x: 1820,
    y: 52.400000000000006,
  },
  {
    x: 1840,
    y: 47.6,
  },
  {
    x: 1860,
    y: 42.800000000000004,
  },
  {
    x: 1880,
    y: 38.800000000000004,
  },
  {
    x: 1900,
    y: 34.800000000000004,
  },
  {
    x: 1920,
    y: 31.6,
  },
  {
    x: 1940,
    y: 28.400000000000002,
  },
  {
    x: 1960,
    y: 26,
  },
  {
    x: 1980,
    y: 24,
  },
  {
    x: 2000,
    y: 22,
  },
  {
    x: 2020,
    y: 20.8,
  },
  {
    x: 2040,
    y: 19.6,
  },
  {
    x: 2060,
    y: 18.8,
  },
  {
    x: 2080,
    y: 18,
  },
  {
    x: 2100,
    y: 17.6,
  },
  {
    x: 2120,
    y: 17.2,
  },
  {
    x: 2140,
    y: 17.2,
  },
  {
    x: 2160,
    y: 16.8,
  },
  {
    x: 2180,
    y: 16.8,
  },
  {
    x: 2200,
    y: 16.400000000000002,
  },
  {
    x: 2220,
    y: 16.400000000000002,
  },
  {
    x: 2240,
    y: 16.400000000000002,
  },
  {
    x: 2260,
    y: 16.400000000000002,
  },
  {
    x: 2280,
    y: 16.400000000000002,
  },
  {
    x: 2300,
    y: 16.400000000000002,
  },
  {
    x: 2320,
    y: 16.400000000000002,
  },
  {
    x: 2340,
    y: 16.400000000000002,
  },
  {
    x: 2360,
    y: 16.400000000000002,
  },
  {
    x: 2380,
    y: 16.400000000000002,
  },
  {
    x: 2400,
    y: 16.400000000000002,
  },
  {
    x: 2420,
    y: 16.400000000000002,
  },
  {
    x: 2440,
    y: 16.400000000000002,
  },
  {
    x: 2460,
    y: 16.400000000000002,
  },
  {
    x: 2480,
    y: 16.400000000000002,
  },
  {
    x: 2500,
    y: 16.400000000000002,
  },
  {
    x: 2520,
    y: 16.400000000000002,
  },
  {
    x: 2540,
    y: 16.400000000000002,
  },
  {
    x: 2560,
    y: 16.400000000000002,
  },
  {
    x: 2580,
    y: 16,
  },
  {
    x: 2600,
    y: 16,
  },
  {
    x: 2620,
    y: 16,
  },
  {
    x: 2640,
    y: 16,
  },
  {
    x: 2660,
    y: 16,
  },
  {
    x: 2680,
    y: 16,
  },
  {
    x: 2700,
    y: 16,
  },
  {
    x: 2720,
    y: 16,
  },
  {
    x: 2740,
    y: 15.600000000000001,
  },
  {
    x: 2760,
    y: 15.600000000000001,
  },
  {
    x: 2780,
    y: 15.600000000000001,
  },
  {
    x: 2800,
    y: 15.600000000000001,
  },
  {
    x: 2820,
    y: 15.600000000000001,
  },
  {
    x: 2840,
    y: 15.600000000000001,
  },
  {
    x: 2860,
    y: 15.600000000000001,
  },
  {
    x: 2880,
    y: 15.200000000000001,
  },
  {
    x: 2900,
    y: 15.200000000000001,
  },
  {
    x: 2920,
    y: 15.200000000000001,
  },
  {
    x: 2940,
    y: 15.200000000000001,
  },
  {
    x: 2960,
    y: 15.200000000000001,
  },
  {
    x: 2980,
    y: 15.200000000000001,
  },
  {
    x: 3000,
    y: 14.8,
  },
  {
    x: 3020,
    y: 14.8,
  },
  {
    x: 3040,
    y: 14.8,
  },
  {
    x: 3060,
    y: 14.8,
  },
  {
    x: 3080,
    y: 14.8,
  },
  {
    x: 3100,
    y: 14.8,
  },
  {
    x: 3120,
    y: 14.8,
  },
  {
    x: 3140,
    y: 14.4,
  },
  {
    x: 3160,
    y: 14.4,
  },
  {
    x: 3180,
    y: 14.4,
  },
  {
    x: 3200,
    y: 14.4,
  },
  {
    x: 3220,
    y: 14.4,
  },
  {
    x: 3240,
    y: 14.4,
  },
  {
    x: 3260,
    y: 14.4,
  },
  {
    x: 3280,
    y: 14,
  },
  {
    x: 3300,
    y: 14,
  },
  {
    x: 3320,
    y: 14,
  },
  {
    x: 3340,
    y: 14,
  },
  {
    x: 3360,
    y: 14,
  },
  {
    x: 3380,
    y: 14,
  },
  {
    x: 3400,
    y: 13.600000000000001,
  },
  {
    x: 3420,
    y: 13.600000000000001,
  },
  {
    x: 3440,
    y: 13.600000000000001,
  },
  {
    x: 3460,
    y: 13.600000000000001,
  },
  {
    x: 3480,
    y: 13.600000000000001,
  },
  {
    x: 3500,
    y: 13.600000000000001,
  },
  {
    x: 3520,
    y: 13.600000000000001,
  },
  {
    x: 3540,
    y: 13.600000000000001,
  },
  {
    x: 3560,
    y: 13.600000000000001,
  },
  {
    x: 3580,
    y: 13.200000000000001,
  },
  {
    x: 3600,
    y: 13.200000000000001,
  },
  {
    x: 3620,
    y: 13.200000000000001,
  },
  {
    x: 3640,
    y: 13.200000000000001,
  },
  {
    x: 3660,
    y: 13.200000000000001,
  },
  {
    x: 3680,
    y: 13.200000000000001,
  },
  {
    x: 3700,
    y: 13.200000000000001,
  },
  {
    x: 3720,
    y: 13.200000000000001,
  },
  {
    x: 3740,
    y: 0.8,
  },
  {
    x: 3760,
    y: 2.8000000000000003,
  },
  {
    x: 3780,
    y: 6.4,
  },
  {
    x: 3800,
    y: 11.600000000000001,
  },
  {
    x: 3820,
    y: 18,
  },
  {
    x: 3840,
    y: 26,
  },
  {
    x: 3860,
    y: 35.6,
  },
  {
    x: 3880,
    y: 46.400000000000006,
  },
  {
    x: 3900,
    y: 58.800000000000004,
  },
  {
    x: 3920,
    y: 70.8,
  },
  {
    x: 3940,
    y: 82.80000000000001,
  },
  {
    x: 3960,
    y: 95.2,
  },
  {
    x: 3980,
    y: 107.2,
  },
  {
    x: 4000,
    y: 119.2,
  },
  {
    x: 4020,
    y: 131.6,
  },
  {
    x: 4040,
    y: 143.6,
  },
  {
    x: 4060,
    y: 155.60000000000002,
  },
  {
    x: 4080,
    y: 168,
  },
  {
    x: 4100,
    y: 180,
  },
  {
    x: 4120,
    y: 192,
  },
  {
    x: 4140,
    y: 204.4,
  },
  {
    x: 4160,
    y: 216.4,
  },
  {
    x: 4180,
    y: 228.8,
  },
  {
    x: 4200,
    y: 240.8,
  },
  {
    x: 4220,
    y: 252.8,
  },
  {
    x: 4240,
    y: 265.2,
  },
  {
    x: 4260,
    y: 277.2,
  },
  {
    x: 4280,
    y: 289.2,
  },
  {
    x: 4300,
    y: 301.6,
  },
  {
    x: 4320,
    y: 313.6,
  },
  {
    x: 4340,
    y: 325.6,
  },
  {
    x: 4360,
    y: 338,
  },
  {
    x: 4380,
    y: 350,
  },
  {
    x: 4400,
    y: 362.40000000000003,
  },
  {
    x: 4420,
    y: 374.40000000000003,
  },
  {
    x: 4440,
    y: 386.40000000000003,
  },
  {
    x: 4460,
    y: 398.8,
  },
  {
    x: 4480,
    y: 410.8,
  },
  {
    x: 4500,
    y: 422.8,
  },
  {
    x: 4520,
    y: 435.20000000000005,
  },
  {
    x: 4540,
    y: 447.20000000000005,
  },
  {
    x: 4560,
    y: 459.20000000000005,
  },
  {
    x: 4580,
    y: 471.6,
  },
  {
    x: 4600,
    y: 483.6,
  },
  {
    x: 4620,
    y: 495.6,
  },
  {
    x: 4640,
    y: 498.8,
  },
  {
    x: 4660,
    y: 498.8,
  },
  {
    x: 4680,
    y: 498.8,
  },
  {
    x: 4700,
    y: 498.8,
  },
  {
    x: 4720,
    y: 498.8,
  },
  {
    x: 4740,
    y: 498.8,
  },
  {
    x: 4760,
    y: 498.8,
  },
  {
    x: 4780,
    y: 498.8,
  },
  {
    x: 4800,
    y: 498.8,
  },
  {
    x: 4820,
    y: 498.8,
  },
  {
    x: 4840,
    y: 499.20000000000005,
  },
  {
    x: 4860,
    y: 499.20000000000005,
  },
  {
    x: 4880,
    y: 499.20000000000005,
  },
  {
    x: 4900,
    y: 499.20000000000005,
  },
  {
    x: 4920,
    y: 499.20000000000005,
  },
  {
    x: 4940,
    y: 499.20000000000005,
  },
  {
    x: 4960,
    y: 499.20000000000005,
  },
  {
    x: 4980,
    y: 499.20000000000005,
  },
  {
    x: 5000,
    y: 499.20000000000005,
  },
  {
    x: 5020,
    y: 499.20000000000005,
  },
  {
    x: 5040,
    y: 499.20000000000005,
  },
  {
    x: 5060,
    y: 493.6,
  },
  {
    x: 5080,
    y: 473.20000000000005,
  },
  {
    x: 5100,
    y: 454.40000000000003,
  },
  {
    x: 5120,
    y: 438,
  },
  {
    x: 5140,
    y: 420.40000000000003,
  },
  {
    x: 5160,
    y: 404,
  },
  {
    x: 5180,
    y: 388,
  },
  {
    x: 5200,
    y: 372.8,
  },
  {
    x: 5220,
    y: 358.40000000000003,
  },
  {
    x: 5240,
    y: 344.40000000000003,
  },
  {
    x: 5260,
    y: 330,
  },
  {
    x: 5280,
    y: 316.40000000000003,
  },
  {
    x: 5300,
    y: 302.40000000000003,
  },
  {
    x: 5320,
    y: 288.8,
  },
  {
    x: 5340,
    y: 275.6,
  },
  {
    x: 5360,
    y: 262.8,
  },
  {
    x: 5380,
    y: 250.4,
  },
  {
    x: 5400,
    y: 238,
  },
  {
    x: 5420,
    y: 226.4,
  },
  {
    x: 5440,
    y: 214.8,
  },
  {
    x: 5460,
    y: 203.20000000000002,
  },
  {
    x: 5480,
    y: 192.4,
  },
  {
    x: 5500,
    y: 181.60000000000002,
  },
  {
    x: 5520,
    y: 171.20000000000002,
  },
  {
    x: 5540,
    y: 161.20000000000002,
  },
  {
    x: 5560,
    y: 151.6,
  },
  {
    x: 5580,
    y: 142,
  },
  {
    x: 5600,
    y: 132.8,
  },
  {
    x: 5620,
    y: 124,
  },
  {
    x: 5640,
    y: 115.60000000000001,
  },
  {
    x: 5660,
    y: 107.2,
  },
  {
    x: 5680,
    y: 99.60000000000001,
  },
  {
    x: 5700,
    y: 92.4,
  },
  {
    x: 5720,
    y: 85.2,
  },
  {
    x: 5740,
    y: 78.4,
  },
  {
    x: 5760,
    y: 72,
  },
  {
    x: 5780,
    y: 66,
  },
  {
    x: 5800,
    y: 60.400000000000006,
  },
  {
    x: 5820,
    y: 55.2,
  },
  {
    x: 5840,
    y: 50.400000000000006,
  },
  {
    x: 5860,
    y: 46,
  },
  {
    x: 5880,
    y: 41.6,
  },
  {
    x: 5900,
    y: 37.6,
  },
  {
    x: 5920,
    y: 34.4,
  },
  {
    x: 5940,
    y: 31.200000000000003,
  },
  {
    x: 5960,
    y: 28.8,
  },
  {
    x: 5980,
    y: 26.400000000000002,
  },
  {
    x: 6000,
    y: 24.8,
  },
  {
    x: 6020,
    y: 23.200000000000003,
  },
  {
    x: 6040,
    y: 22.400000000000002,
  },
  {
    x: 6060,
    y: 21.6,
  },
  {
    x: 6080,
    y: 21.200000000000003,
  },
  {
    x: 6100,
    y: 20.400000000000002,
  },
  {
    x: 6120,
    y: 20.400000000000002,
  },
  {
    x: 6140,
    y: 20,
  },
  {
    x: 6160,
    y: 19.6,
  },
  {
    x: 6180,
    y: 19.6,
  },
  {
    x: 6200,
    y: 19.6,
  },
  {
    x: 6220,
    y: 19.6,
  },
  {
    x: 6240,
    y: 19.6,
  },
  {
    x: 6260,
    y: 19.6,
  },
  {
    x: 6280,
    y: 19.6,
  },
  {
    x: 6300,
    y: 19.6,
  },
  {
    x: 6320,
    y: 19.6,
  },
  {
    x: 6340,
    y: 19.6,
  },
  {
    x: 6360,
    y: 19.6,
  },
  {
    x: 6380,
    y: 19.6,
  },
  {
    x: 6400,
    y: 19.6,
  },
  {
    x: 6420,
    y: 19.200000000000003,
  },
  {
    x: 6440,
    y: 19.200000000000003,
  },
  {
    x: 6460,
    y: 19.200000000000003,
  },
  {
    x: 6480,
    y: 19.200000000000003,
  },
  {
    x: 6500,
    y: 19.200000000000003,
  },
  {
    x: 6520,
    y: 19.200000000000003,
  },
  {
    x: 6540,
    y: 19.200000000000003,
  },
  {
    x: 6560,
    y: 19.200000000000003,
  },
  {
    x: 6580,
    y: 19.200000000000003,
  },
  {
    x: 6600,
    y: 19.200000000000003,
  },
  {
    x: 6620,
    y: 19.200000000000003,
  },
  {
    x: 6640,
    y: 19.200000000000003,
  },
  {
    x: 6660,
    y: 18.8,
  },
  {
    x: 6680,
    y: 18.8,
  },
  {
    x: 6700,
    y: 18.8,
  },
  {
    x: 6720,
    y: 18.8,
  },
  {
    x: 6740,
    y: 18.8,
  },
  {
    x: 6760,
    y: 18.8,
  },
  {
    x: 6780,
    y: 18.400000000000002,
  },
  {
    x: 6800,
    y: 18.400000000000002,
  },
  {
    x: 6820,
    y: 18.400000000000002,
  },
  {
    x: 6840,
    y: 18.400000000000002,
  },
  {
    x: 6860,
    y: 18.400000000000002,
  },
  {
    x: 6880,
    y: 18.400000000000002,
  },
  {
    x: 6900,
    y: 18,
  },
  {
    x: 6920,
    y: 18,
  },
  {
    x: 6940,
    y: 18,
  },
  {
    x: 6960,
    y: 18,
  },
  {
    x: 6980,
    y: 18,
  },
  {
    x: 7000,
    y: 18,
  },
  {
    x: 7020,
    y: 18,
  },
  {
    x: 7040,
    y: 17.6,
  },
  {
    x: 7060,
    y: 17.6,
  },
  {
    x: 7080,
    y: 17.6,
  },
  {
    x: 7100,
    y: 17.6,
  },
  {
    x: 7120,
    y: 17.6,
  },
  {
    x: 7140,
    y: 17.6,
  },
  {
    x: 7160,
    y: 17.6,
  },
  {
    x: 7180,
    y: 17.2,
  },
  {
    x: 7200,
    y: 17.2,
  },
  {
    x: 7220,
    y: 17.2,
  },
  {
    x: 7240,
    y: 17.2,
  },
  {
    x: 7260,
    y: 17.2,
  },
  {
    x: 7280,
    y: 17.2,
  },
  {
    x: 7300,
    y: 17.2,
  },
  {
    x: 7320,
    y: 16.8,
  },
  {
    x: 7340,
    y: 16.8,
  },
  {
    x: 7360,
    y: 16.8,
  },
  {
    x: 7380,
    y: 16.8,
  },
  {
    x: 7400,
    y: 16.8,
  },
  {
    x: 7420,
    y: 16.8,
  },
  {
    x: 7440,
    y: 16.8,
  },
  {
    x: 7460,
    y: 16.400000000000002,
  },
  {
    x: 7480,
    y: 16.400000000000002,
  },
  {
    x: 7500,
    y: 16.400000000000002,
  },
  {
    x: 7520,
    y: 16.400000000000002,
  },
  {
    x: 7540,
    y: 16.400000000000002,
  },
  {
    x: 7560,
    y: 16.400000000000002,
  },
  {
    x: 7580,
    y: 16.400000000000002,
  },
  {
    x: 7600,
    y: 16.400000000000002,
  },
  {
    x: 7620,
    y: 16.400000000000002,
  },
  {
    x: 7640,
    y: 16,
  },
  {
    x: 7660,
    y: 16,
  },
  {
    x: 7680,
    y: 16,
  },
  {
    x: 7700,
    y: 16,
  },
  {
    x: 7720,
    y: 16,
  },
  {
    x: 7740,
    y: 0.8,
  },
  {
    x: 7760,
    y: 2.8000000000000003,
  },
  {
    x: 7780,
    y: 6.4,
  },
  {
    x: 7800,
    y: 11.200000000000001,
  },
  {
    x: 7820,
    y: 17.6,
  },
  {
    x: 7840,
    y: 25.6,
  },
  {
    x: 7860,
    y: 34.800000000000004,
  },
  {
    x: 7880,
    y: 45.6,
  },
  {
    x: 7900,
    y: 58.400000000000006,
  },
  {
    x: 7920,
    y: 70.4,
  },
  {
    x: 7940,
    y: 82.80000000000001,
  },
  {
    x: 7960,
    y: 94.80000000000001,
  },
  {
    x: 7980,
    y: 106.80000000000001,
  },
  {
    x: 8000,
    y: 118.80000000000001,
  },
  {
    x: 8020,
    y: 131.20000000000002,
  },
  {
    x: 8040,
    y: 143.20000000000002,
  },
  {
    x: 8060,
    y: 155.20000000000002,
  },
  {
    x: 8080,
    y: 167.60000000000002,
  },
  {
    x: 8100,
    y: 179.60000000000002,
  },
  {
    x: 8120,
    y: 191.60000000000002,
  },
  {
    x: 8140,
    y: 204,
  },
  {
    x: 8160,
    y: 216,
  },
  {
    x: 8180,
    y: 228,
  },
  {
    x: 8200,
    y: 240.4,
  },
  {
    x: 8220,
    y: 252.4,
  },
  {
    x: 8240,
    y: 264.40000000000003,
  },
  {
    x: 8260,
    y: 276.8,
  },
  {
    x: 8280,
    y: 288.8,
  },
  {
    x: 8300,
    y: 300.8,
  },
  {
    x: 8320,
    y: 313.20000000000005,
  },
  {
    x: 8340,
    y: 325.20000000000005,
  },
  {
    x: 8360,
    y: 337.20000000000005,
  },
  {
    x: 8380,
    y: 349.6,
  },
  {
    x: 8400,
    y: 361.6,
  },
  {
    x: 8420,
    y: 373.6,
  },
  {
    x: 8440,
    y: 386,
  },
  {
    x: 8460,
    y: 398,
  },
  {
    x: 8480,
    y: 410,
  },
  {
    x: 8500,
    y: 422.40000000000003,
  },
  {
    x: 8520,
    y: 434.40000000000003,
  },
  {
    x: 8540,
    y: 446.40000000000003,
  },
  {
    x: 8560,
    y: 458.8,
  },
  {
    x: 8580,
    y: 470.8,
  },
  {
    x: 8600,
    y: 482.8,
  },
  {
    x: 8620,
    y: 495.20000000000005,
  },
  {
    x: 8640,
    y: 499.20000000000005,
  },
  {
    x: 8660,
    y: 499.6,
  },
  {
    x: 8680,
    y: 499.6,
  },
  {
    x: 8700,
    y: 499.6,
  },
  {
    x: 8720,
    y: 499.6,
  },
  {
    x: 8740,
    y: 499.6,
  },
  {
    x: 8760,
    y: 499.6,
  },
  {
    x: 8780,
    y: 499.6,
  },
  {
    x: 8800,
    y: 499.6,
  },
  {
    x: 8820,
    y: 499.6,
  },
  {
    x: 8840,
    y: 499.6,
  },
  {
    x: 8860,
    y: 499.6,
  },
  {
    x: 8880,
    y: 499.6,
  },
  {
    x: 8900,
    y: 499.6,
  },
  {
    x: 8920,
    y: 499.6,
  },
  {
    x: 8940,
    y: 499.6,
  },
  {
    x: 8960,
    y: 499.6,
  },
  {
    x: 8980,
    y: 499.6,
  },
  {
    x: 9000,
    y: 499.6,
  },
  {
    x: 9020,
    y: 499.6,
  },
  {
    x: 9040,
    y: 499.6,
  },
  {
    x: 9060,
    y: 495.6,
  },
  {
    x: 9080,
    y: 475.6,
  },
  {
    x: 9100,
    y: 456.40000000000003,
  },
  {
    x: 9120,
    y: 439.20000000000005,
  },
  {
    x: 9140,
    y: 421.20000000000005,
  },
  {
    x: 9160,
    y: 405.20000000000005,
  },
  {
    x: 9180,
    y: 388.8,
  },
  {
    x: 9200,
    y: 373.6,
  },
  {
    x: 9220,
    y: 358.8,
  },
  {
    x: 9240,
    y: 344.8,
  },
  {
    x: 9260,
    y: 330.40000000000003,
  },
  {
    x: 9280,
    y: 316.8,
  },
  {
    x: 9300,
    y: 302.8,
  },
  {
    x: 9320,
    y: 289.6,
  },
  {
    x: 9340,
    y: 276.40000000000003,
  },
  {
    x: 9360,
    y: 263.6,
  },
  {
    x: 9380,
    y: 251.20000000000002,
  },
  {
    x: 9400,
    y: 238.8,
  },
  {
    x: 9420,
    y: 226.8,
  },
  {
    x: 9440,
    y: 215.20000000000002,
  },
  {
    x: 9460,
    y: 204,
  },
  {
    x: 9480,
    y: 192.8,
  },
  {
    x: 9500,
    y: 182,
  },
  {
    x: 9520,
    y: 171.60000000000002,
  },
  {
    x: 9540,
    y: 161.60000000000002,
  },
  {
    x: 9560,
    y: 152,
  },
  {
    x: 9580,
    y: 142.4,
  },
  {
    x: 9600,
    y: 133.20000000000002,
  },
  {
    x: 9620,
    y: 124.4,
  },
  {
    x: 9640,
    y: 115.60000000000001,
  },
  {
    x: 9660,
    y: 107.60000000000001,
  },
  {
    x: 9680,
    y: 100,
  },
  {
    x: 9700,
    y: 92.4,
  },
  {
    x: 9720,
    y: 85.2,
  },
  {
    x: 9740,
    y: 78.4,
  },
  {
    x: 9760,
    y: 72,
  },
  {
    x: 9780,
    y: 66,
  },
  {
    x: 9800,
    y: 60,
  },
  {
    x: 9820,
    y: 54.800000000000004,
  },
  {
    x: 9840,
    y: 50,
  },
  {
    x: 9860,
    y: 45.6,
  },
  {
    x: 9880,
    y: 41.2,
  },
  {
    x: 9900,
    y: 37.2,
  },
  {
    x: 9920,
    y: 34,
  },
  {
    x: 9940,
    y: 31.200000000000003,
  },
  {
    x: 9960,
    y: 28.400000000000002,
  },
  {
    x: 9980,
    y: 26.400000000000002,
  },
  {
    x: 10000,
    y: 24.400000000000002,
  },
  {
    x: 10020,
    y: 22.8,
  },
  {
    x: 10040,
    y: 21.6,
  },
  {
    x: 10060,
    y: 20.8,
  },
  {
    x: 10080,
    y: 20.400000000000002,
  },
  {
    x: 10100,
    y: 19.6,
  },
  {
    x: 10120,
    y: 19.6,
  },
  {
    x: 10140,
    y: 19.200000000000003,
  },
  {
    x: 10160,
    y: 19.200000000000003,
  },
  {
    x: 10180,
    y: 19.200000000000003,
  },
  {
    x: 10200,
    y: 18.8,
  },
  {
    x: 10220,
    y: 18.8,
  },
  {
    x: 10240,
    y: 18.8,
  },
  {
    x: 10260,
    y: 18.8,
  },
  {
    x: 10280,
    y: 18.8,
  },
  {
    x: 10300,
    y: 18.8,
  },
  {
    x: 10320,
    y: 18.8,
  },
  {
    x: 10340,
    y: 18.8,
  },
  {
    x: 10360,
    y: 18.8,
  },
  {
    x: 10380,
    y: 18.8,
  },
  {
    x: 10400,
    y: 18.8,
  },
  {
    x: 10420,
    y: 18.8,
  },
  {
    x: 10440,
    y: 18.8,
  },
  {
    x: 10460,
    y: 18.8,
  },
  {
    x: 10480,
    y: 18.8,
  },
  {
    x: 10500,
    y: 18.8,
  },
  {
    x: 10520,
    y: 18.400000000000002,
  },
  {
    x: 10540,
    y: 18.400000000000002,
  },
  {
    x: 10560,
    y: 18.400000000000002,
  },
  {
    x: 10580,
    y: 18.400000000000002,
  },
  {
    x: 10600,
    y: 18.400000000000002,
  },
  {
    x: 10620,
    y: 18.400000000000002,
  },
  {
    x: 10640,
    y: 18.400000000000002,
  },
  {
    x: 10660,
    y: 18.400000000000002,
  },
  {
    x: 10680,
    y: 18.400000000000002,
  },
  {
    x: 10700,
    y: 18.400000000000002,
  },
  {
    x: 10720,
    y: 18,
  },
  {
    x: 10740,
    y: 18,
  },
  {
    x: 10760,
    y: 18,
  },
  {
    x: 10780,
    y: 18,
  },
  {
    x: 10800,
    y: 18,
  },
  {
    x: 10820,
    y: 18,
  },
  {
    x: 10840,
    y: 18,
  },
  {
    x: 10860,
    y: 17.6,
  },
  {
    x: 10880,
    y: 17.6,
  },
  {
    x: 10900,
    y: 17.6,
  },
  {
    x: 10920,
    y: 17.6,
  },
  {
    x: 10940,
    y: 17.6,
  },
  {
    x: 10960,
    y: 17.6,
  },
  {
    x: 10980,
    y: 17.6,
  },
  {
    x: 11000,
    y: 17.2,
  },
  {
    x: 11020,
    y: 17.2,
  },
  {
    x: 11040,
    y: 17.2,
  },
  {
    x: 11060,
    y: 17.2,
  },
  {
    x: 11080,
    y: 17.2,
  },
  {
    x: 11100,
    y: 17.2,
  },
  {
    x: 11120,
    y: 17.2,
  },
  {
    x: 11140,
    y: 16.8,
  },
  {
    x: 11160,
    y: 16.8,
  },
  {
    x: 11180,
    y: 16.8,
  },
  {
    x: 11200,
    y: 16.8,
  },
  {
    x: 11220,
    y: 16.8,
  },
  {
    x: 11240,
    y: 16.8,
  },
  {
    x: 11260,
    y: 16.400000000000002,
  },
  {
    x: 11280,
    y: 16.400000000000002,
  },
  {
    x: 11300,
    y: 16.400000000000002,
  },
  {
    x: 11320,
    y: 16.400000000000002,
  },
  {
    x: 11340,
    y: 16.400000000000002,
  },
  {
    x: 11360,
    y: 16.400000000000002,
  },
  {
    x: 11380,
    y: 16.400000000000002,
  },
  {
    x: 11400,
    y: 16,
  },
  {
    x: 11420,
    y: 16,
  },
  {
    x: 11440,
    y: 16,
  },
  {
    x: 11460,
    y: 16,
  },
  {
    x: 11480,
    y: 16,
  },
  {
    x: 11500,
    y: 16,
  },
  {
    x: 11520,
    y: 16,
  },
  {
    x: 11540,
    y: 16,
  },
  {
    x: 11560,
    y: 16,
  },
  {
    x: 11580,
    y: 16,
  },
  {
    x: 11600,
    y: 15.600000000000001,
  },
  {
    x: 11620,
    y: 15.600000000000001,
  },
  {
    x: 11640,
    y: 15.600000000000001,
  },
  {
    x: 11660,
    y: 15.600000000000001,
  },
  {
    x: 11680,
    y: 15.600000000000001,
  },
  {
    x: 11700,
    y: 15.600000000000001,
  },
  {
    x: 11720,
    y: 15.200000000000001,
  },
  {
    x: 11740,
    y: 0.4,
  },
  {
    x: 11760,
    y: 2.4000000000000004,
  },
  {
    x: 11780,
    y: 5.6000000000000005,
  },
  {
    x: 11800,
    y: 10.4,
  },
  {
    x: 11820,
    y: 16.400000000000002,
  },
  {
    x: 11840,
    y: 24.400000000000002,
  },
  {
    x: 11860,
    y: 33.6,
  },
  {
    x: 11880,
    y: 44.400000000000006,
  },
  {
    x: 11900,
    y: 56.800000000000004,
  },
  {
    x: 11920,
    y: 68.8,
  },
  {
    x: 11940,
    y: 81.2,
  },
  {
    x: 11960,
    y: 93.2,
  },
  {
    x: 11980,
    y: 105.2,
  },
  {
    x: 12000,
    y: 117.60000000000001,
  },
  {
    x: 12020,
    y: 129.6,
  },
  {
    x: 12040,
    y: 141.6,
  },
  {
    x: 12060,
    y: 154,
  },
  {
    x: 12080,
    y: 166,
  },
  {
    x: 12100,
    y: 178,
  },
  {
    x: 12120,
    y: 190.4,
  },
  {
    x: 12140,
    y: 202.4,
  },
  {
    x: 12160,
    y: 214.4,
  },
  {
    x: 12180,
    y: 226.8,
  },
  {
    x: 12200,
    y: 238.8,
  },
  {
    x: 12220,
    y: 250.8,
  },
  {
    x: 12240,
    y: 263.2,
  },
  {
    x: 12260,
    y: 275.2,
  },
  {
    x: 12280,
    y: 287.2,
  },
  {
    x: 12300,
    y: 299.6,
  },
  {
    x: 12320,
    y: 311.6,
  },
  {
    x: 12340,
    y: 323.6,
  },
  {
    x: 12360,
    y: 336,
  },
  {
    x: 12380,
    y: 348,
  },
  {
    x: 12400,
    y: 360.40000000000003,
  },
  {
    x: 12420,
    y: 372.40000000000003,
  },
  {
    x: 12440,
    y: 384.40000000000003,
  },
  {
    x: 12460,
    y: 396.8,
  },
  {
    x: 12480,
    y: 408.8,
  },
  {
    x: 12500,
    y: 420.8,
  },
  {
    x: 12520,
    y: 433.20000000000005,
  },
  {
    x: 12540,
    y: 445.20000000000005,
  },
  {
    x: 12560,
    y: 457.20000000000005,
  },
  {
    x: 12580,
    y: 469.20000000000005,
  },
  {
    x: 12600,
    y: 481.6,
  },
  {
    x: 12620,
    y: 493.6,
  },
  {
    x: 12640,
    y: 498.8,
  },
  {
    x: 12660,
    y: 498.8,
  },
  {
    x: 12680,
    y: 498.8,
  },
  {
    x: 12700,
    y: 498.8,
  },
  {
    x: 12720,
    y: 498.8,
  },
  {
    x: 12740,
    y: 498.8,
  },
  {
    x: 12760,
    y: 498.8,
  },
  {
    x: 12780,
    y: 498.8,
  },
  {
    x: 12800,
    y: 498.8,
  },
  {
    x: 12820,
    y: 498.8,
  },
  {
    x: 12840,
    y: 499.20000000000005,
  },
  {
    x: 12860,
    y: 499.20000000000005,
  },
  {
    x: 12880,
    y: 499.20000000000005,
  },
  {
    x: 12900,
    y: 499.20000000000005,
  },
  {
    x: 12920,
    y: 499.20000000000005,
  },
  {
    x: 12940,
    y: 499.20000000000005,
  },
  {
    x: 12960,
    y: 499.20000000000005,
  },
  {
    x: 12980,
    y: 499.20000000000005,
  },
  {
    x: 13000,
    y: 499.20000000000005,
  },
  {
    x: 13020,
    y: 499.20000000000005,
  },
  {
    x: 13040,
    y: 499.20000000000005,
  },
  {
    x: 13060,
    y: 496.40000000000003,
  },
  {
    x: 13080,
    y: 478,
  },
  {
    x: 13100,
    y: 458,
  },
  {
    x: 13120,
    y: 441.20000000000005,
  },
  {
    x: 13140,
    y: 423.6,
  },
  {
    x: 13160,
    y: 406.8,
  },
  {
    x: 13180,
    y: 390.8,
  },
  {
    x: 13200,
    y: 375.6,
  },
  {
    x: 13220,
    y: 360.8,
  },
  {
    x: 13240,
    y: 346.40000000000003,
  },
  {
    x: 13260,
    y: 332.40000000000003,
  },
  {
    x: 13280,
    y: 318.40000000000003,
  },
  {
    x: 13300,
    y: 304.40000000000003,
  },
  {
    x: 13320,
    y: 290.8,
  },
  {
    x: 13340,
    y: 277.6,
  },
  {
    x: 13360,
    y: 264.8,
  },
  {
    x: 13380,
    y: 252,
  },
  {
    x: 13400,
    y: 240,
  },
  {
    x: 13420,
    y: 228,
  },
  {
    x: 13440,
    y: 216.4,
  },
  {
    x: 13460,
    y: 205.20000000000002,
  },
  {
    x: 13480,
    y: 194,
  },
  {
    x: 13500,
    y: 183.20000000000002,
  },
  {
    x: 13520,
    y: 172.8,
  },
  {
    x: 13540,
    y: 162.4,
  },
  {
    x: 13560,
    y: 152.8,
  },
  {
    x: 13580,
    y: 143.20000000000002,
  },
  {
    x: 13600,
    y: 134.4,
  },
  {
    x: 13620,
    y: 125.60000000000001,
  },
  {
    x: 13640,
    y: 117.2,
  },
  {
    x: 13660,
    y: 109.2,
  },
  {
    x: 13680,
    y: 101.2,
  },
  {
    x: 13700,
    y: 93.60000000000001,
  },
  {
    x: 13720,
    y: 86.80000000000001,
  },
  {
    x: 13740,
    y: 80,
  },
  {
    x: 13760,
    y: 73.60000000000001,
  },
  {
    x: 13780,
    y: 67.60000000000001,
  },
  {
    x: 13800,
    y: 62,
  },
  {
    x: 13820,
    y: 56.800000000000004,
  },
  {
    x: 13840,
    y: 51.6,
  },
  {
    x: 13860,
    y: 47.2,
  },
  {
    x: 13880,
    y: 42.800000000000004,
  },
  {
    x: 13900,
    y: 38.800000000000004,
  },
  {
    x: 13920,
    y: 35.6,
  },
  {
    x: 13940,
    y: 32.4,
  },
  {
    x: 13960,
    y: 30,
  },
  {
    x: 13980,
    y: 27.6,
  },
  {
    x: 14000,
    y: 25.6,
  },
  {
    x: 14020,
    y: 24,
  },
  {
    x: 14040,
    y: 22.8,
  },
  {
    x: 14060,
    y: 22,
  },
  {
    x: 14080,
    y: 21.6,
  },
  {
    x: 14100,
    y: 20.8,
  },
  {
    x: 14120,
    y: 20.8,
  },
  {
    x: 14140,
    y: 20.400000000000002,
  },
  {
    x: 14160,
    y: 20,
  },
  {
    x: 14180,
    y: 20,
  },
  {
    x: 14200,
    y: 20,
  },
  {
    x: 14220,
    y: 20,
  },
  {
    x: 14240,
    y: 20,
  },
  {
    x: 14260,
    y: 20,
  },
  {
    x: 14280,
    y: 19.6,
  },
  {
    x: 14300,
    y: 19.6,
  },
  {
    x: 14320,
    y: 19.6,
  },
  {
    x: 14340,
    y: 19.6,
  },
  {
    x: 14360,
    y: 19.6,
  },
  {
    x: 14380,
    y: 19.6,
  },
  {
    x: 14400,
    y: 19.6,
  },
  {
    x: 14420,
    y: 19.6,
  },
  {
    x: 14440,
    y: 19.6,
  },
  {
    x: 14460,
    y: 19.6,
  },
  {
    x: 14480,
    y: 19.6,
  },
  {
    x: 14500,
    y: 19.6,
  },
  {
    x: 14520,
    y: 19.6,
  },
  {
    x: 14540,
    y: 19.6,
  },
  {
    x: 14560,
    y: 19.6,
  },
  {
    x: 14580,
    y: 19.6,
  },
  {
    x: 14600,
    y: 19.6,
  },
  {
    x: 14620,
    y: 19.6,
  },
  {
    x: 14640,
    y: 19.6,
  },
  {
    x: 14660,
    y: 19.6,
  },
  {
    x: 14680,
    y: 19.200000000000003,
  },
  {
    x: 14700,
    y: 19.200000000000003,
  },
  {
    x: 14720,
    y: 19.200000000000003,
  },
  {
    x: 14740,
    y: 19.200000000000003,
  },
  {
    x: 14760,
    y: 19.200000000000003,
  },
  {
    x: 14780,
    y: 19.200000000000003,
  },
  {
    x: 14800,
    y: 18.8,
  },
  {
    x: 14820,
    y: 18.8,
  },
  {
    x: 14840,
    y: 18.8,
  },
  {
    x: 14860,
    y: 18.8,
  },
  {
    x: 14880,
    y: 18.8,
  },
  {
    x: 14900,
    y: 18.8,
  },
  {
    x: 14920,
    y: 18.400000000000002,
  },
  {
    x: 14940,
    y: 18.400000000000002,
  },
  {
    x: 14960,
    y: 18.400000000000002,
  },
  {
    x: 14980,
    y: 18.400000000000002,
  },
  {
    x: 15000,
    y: 18.400000000000002,
  },
  {
    x: 15020,
    y: 18.400000000000002,
  },
  {
    x: 15040,
    y: 18,
  },
  {
    x: 15060,
    y: 18,
  },
  {
    x: 15080,
    y: 18,
  },
  {
    x: 15100,
    y: 18,
  },
  {
    x: 15120,
    y: 18,
  },
  {
    x: 15140,
    y: 18,
  },
  {
    x: 15160,
    y: 17.6,
  },
  {
    x: 15180,
    y: 17.6,
  },
  {
    x: 15200,
    y: 17.6,
  },
  {
    x: 15220,
    y: 17.6,
  },
  {
    x: 15240,
    y: 17.6,
  },
  {
    x: 15260,
    y: 17.6,
  },
  {
    x: 15280,
    y: 17.6,
  },
  {
    x: 15300,
    y: 17.2,
  },
  {
    x: 15320,
    y: 17.2,
  },
  {
    x: 15340,
    y: 17.2,
  },
  {
    x: 15360,
    y: 17.2,
  },
  {
    x: 15380,
    y: 17.2,
  },
  {
    x: 15400,
    y: 17.2,
  },
  {
    x: 15420,
    y: 17.2,
  },
  {
    x: 15440,
    y: 16.8,
  },
  {
    x: 15460,
    y: 16.8,
  },
  {
    x: 15480,
    y: 16.8,
  },
  {
    x: 15500,
    y: 16.8,
  },
  {
    x: 15520,
    y: 16.8,
  },
  {
    x: 15540,
    y: 16.8,
  },
  {
    x: 15560,
    y: 16.8,
  },
  {
    x: 15580,
    y: 16.8,
  },
  {
    x: 15600,
    y: 16.8,
  },
  {
    x: 15620,
    y: 16.400000000000002,
  },
  {
    x: 15640,
    y: 16.400000000000002,
  },
  {
    x: 15660,
    y: 16.400000000000002,
  },
  {
    x: 15680,
    y: 16.400000000000002,
  },
  {
    x: 15700,
    y: 16.400000000000002,
  },
  {
    x: 15720,
    y: 16.400000000000002,
  },
  {
    x: 15740,
    y: 16.400000000000002,
  },
  {
    x: 15760,
    y: 1.2000000000000002,
  },
  {
    x: 15780,
    y: 4.4,
  },
  {
    x: 15800,
    y: 8.8,
  },
  {
    x: 15820,
    y: 15.200000000000001,
  },
  {
    x: 15840,
    y: 22.8,
  },
  {
    x: 15860,
    y: 31.6,
  },
  {
    x: 15880,
    y: 42,
  },
  {
    x: 15900,
    y: 54,
  },
  {
    x: 15920,
    y: 66.4,
  },
  {
    x: 15940,
    y: 78.4,
  },
  {
    x: 15960,
    y: 90.4,
  },
  {
    x: 15980,
    y: 102.80000000000001,
  },
];
